// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Styled_smallBoxInner__2YNnC {\n  background-color: white;\n  height: 380px;\n}\n\n.Styled_windowHeight__1uxrr {\n  height: 94vh;\n}\n", "",{"version":3,"sources":["webpack://src/components/Admin/Styled/Styled.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;AACd","sourcesContent":[".smallBoxInner {\n  background-color: white;\n  height: 380px;\n}\n\n.windowHeight {\n  height: 94vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smallBoxInner": "Styled_smallBoxInner__2YNnC",
	"windowHeight": "Styled_windowHeight__1uxrr"
};
export default ___CSS_LOADER_EXPORT___;
